/**
 * Onboarding-state keys for the admin-nav changeboarding tour. The tour is a
 * 3-step popover walkthrough shown to product admins the first time they
 * land on Confluence Admin after the RBAC admin modernization experiment
 * ships.
 */

export const CHANGEBOARDING_ADMIN_NAV_TOUR = {
	TOUR_SEEN: 'changeboarding-admin-nav-tour:tourSeen',
} as const;

export const ChangeboardingAdminNavTourOnboardingKeys: readonly [
	'changeboarding-admin-nav-tour:tourSeen',
] = [CHANGEBOARDING_ADMIN_NAV_TOUR.TOUR_SEEN] as const;
